import React from 'react';
import {
  Modal as ReactstrapModal,
  ModalHeader,
  ModalBody,
  ModalFooter,
} from 'reactstrap';

const Modal = ({
  isOpen,
  onClose,
  title,
  size = 'md',
  footer = null,
  children,
}) => {
  return (
    <ReactstrapModal isOpen={isOpen} toggle={onClose} size={size} centered>
      <ModalHeader toggle={onClose}>{title}</ModalHeader>
      <ModalBody>{children}</ModalBody>
      {footer && <ModalFooter>{footer}</ModalFooter>}
    </ReactstrapModal>
  );
};

export default Modal;
